import toHash from "tohash";

export const LANGUAGES = [
  {
    name: "Auto",
    mode: "auto"
  },
  {
    name: "Apache",
    mode: "apache",
    mime: "text/apache",
    custom: true
  },
  {
    name: "Bash",
    mode: "shell",
    mime: "application/x-sh"
  },
  {
    name: "Plain Text",
    mode: "text",
    mime: "text"
  },
  {
    name: "C",
    mode: "clike",
    mime: "text/x-csrc",
    short: "c"
  },
  {
    name: "C++",
    mode: "clike",
    mime: "text/x-c++src",
    short: "cpp"
  },
  {
    name: "C#",
    mode: "clike",
    mime: "text/x-csharp",
    short: "cs"
  },
  {
    name: "Clojure",
    mode: "clojure",
    mime: "text/x-clojure"
  },
  {
    name: "Cobol",
    mode: "cobol",
    mime: "text/x-cobol"
  },
  {
    name: "CoffeeScript",
    mode: "coffeescript",
    mime: "text/coffeescript"
  },
  {
    name: "Crystal",
    mode: "crystal",
    mime: "text/x-crystal"
  },
  {
    name: "CSS",
    mode: "css",
    mime: "text/css"
  },
  {
    name: "D",
    mode: "d",
    mime: "text/x-d"
  },
  {
    name: "Dart",
    mode: "dart",
    mime: "application/dart"
  },
  {
    name: "Diff",
    mode: "diff",
    mime: "text/x-diff"
  },
  {
    name: "Django",
    mode: "django",
    mime: "text/x-django"
  },
  {
    name: "Docker",
    mode: "dockerfile",
    mime: "text/x-dockerfile"
  },
  {
    name: "Elixir",
    mode: "elixir",
    custom: true,
    mime: "text/x-elixir"
  },
  {
    name: "Elm",
    mode: "elm",
    mime: "text/x-elm"
  },
  {
    name: "Erlang",
    mode: "erlang",
    mime: "text/x-erlang"
  },
  {
    name: "Fortran",
    mode: "fortran",
    mime: "text/x-fortran"
  },
  {
    name: "F#",
    mode: "mllike",
    mime: "text/x-fsharp"
  },
  {
    name: "GraphQL",
    mode: "graphql",
    custom: true,
    mime: "text/x-graphql"
  },
  {
    name: "Go",
    mode: "go",
    mime: "text/x-go"
  },
  {
    name: "Groovy",
    mode: "groovy",
    mime: "text/x-groovy"
  },
  {
    name: "Handlebars",
    mode: "handlebars",
    mime: "text/x-handlebars-template"
  },
  {
    name: "Haskell",
    mode: "haskell",
    mime: "text/x-haskell"
  },
  {
    name: "Haxe",
    mode: "haxe",
    mime: "text/x-haxe"
  },
  {
    name: "HTML",
    mode: "htmlmixed",
    mime: "text/html"
  },
  {
    name: "Java",
    mode: "clike",
    mime: "text/x-java",
    short: "java"
  },
  {
    name: "JavaScript",
    mode: "javascript",
    mime: "application/javascript",
    short: "javascript"
  },
  {
    name: "JSON",
    mode: "javascript",
    mime: "application/json",
    short: "json"
  },
  {
    name: "JSX",
    mode: "jsx",
    mime: "text/jsx"
  },
  {
    name: "Julia",
    mode: "julia",
    mime: "text/x-julia"
  },
  {
    name: "Kotlin",
    mode: "clike",
    mime: "text/x-kotlin",
    short: "kotlin"
  },
  {
    name: "LaTeX",
    mode: "sex",
    mime: "text/x-sex"
  },
  {
    name: "Lisp",
    mode: "commonlisp",
    mime: "text/x-common-lisp"
  },
  {
    name: "Lua",
    mode: "lua",
    mime: "text/x-lua"
  },
  {
    name: "Markdown",
    mode: "markdown",
    mime: "text/x-markdown"
  },
  {
    name: "Mathematica",
    mode: "mathematica",
    mime: "text/x-mathematica"
  },
  {
    name: "MATLAB/Octave",
    mode: "octave",
    mime: "text/x-octave"
  },
  {
    name: "MySQL",
    mode: "sql",
    mime: "text/x-mysql",
    short: "mysql"
  },
  {
    name: "N-Triples",
    mode: "ntriples",
    mime: "application/n-triples"
  },
  {
    name: "NGINX",
    mode: "nginx",
    mime: "text/x-nginx-conf"
  },
  {
    name: "Nim",
    mode: "nimrod",
    mime: "text/x-nimrod",
    custom: true
  },
  {
    name: "Objective C",
    mode: "clike",
    mime: "text/x-objectivec",
    short: "objectivec"
  },
  {
    name: "OCaml",
    mode: "mllike",
    mime: "text/x-ocaml"
  },
  {
    name: "Pascal",
    mode: "pascal",
    mime: "text/x-pascal"
  },
  {
    name: "Perl",
    mode: "perl",
    mime: "text/x-perl"
  },
  {
    name: "PHP",
    mode: "php",
    mime: "text/x-php",
    short: "php"
  },
  {
    name: "PowerShell",
    mode: "powershell",
    mime: "application/x-powershell"
  },
  {
    name: "Python",
    mode: "python",
    mime: "text/x-python"
  },
  {
    name: "R",
    mode: "r",
    mime: "text/x-rsrc"
  },
  {
    name: "RISC-V",
    mode: "riscv",
    mime: "text/x-riscv",
    custom: true
  },
  {
    name: "Ruby",
    mode: "ruby",
    mime: "text/x-ruby"
  },
  {
    name: "Rust",
    mode: "rust",
    mime: "text/x-rustsrc"
  },
  {
    name: "Sass",
    mode: "sass",
    mime: "text/x-sass"
  },
  {
    name: "Scala",
    mode: "clike",
    mime: "text/x-scala",
    short: "scala"
  },
  {
    name: "Smalltalk",
    mode: "smalltalk",
    mime: "text/x-stsrc"
  },
  {
    name: "SPARQL",
    mode: "sparql",
    mime: "application/sparql-query"
  },
  {
    name: "SQL",
    mode: "sql",
    mime: "text/x-sql"
  },
  {
    name: "Stylus",
    mode: "stylus",
    mime: "stylus"
  },
  {
    name: "Swift",
    mode: "swift",
    mime: "text/x-swift"
  },
  {
    name: "TCL",
    mode: "tcl",
    mime: "text/x-tcl"
  },
  {
    name: "TOML",
    mode: "toml",
    mime: "text/x-toml"
  },
  {
    name: "Turtle",
    mode: "turtle",
    mime: "text/turtle"
  },
  {
    name: "TypeScript",
    mode: "javascript",
    mime: "application/typescript",
    short: "typescript"
  },
  {
    name: "TSX",
    mode: "jsx",
    mime: "text/typescript-jsx",
    short: "tsx"
  },
  {
    name: "Twig",
    mode: "twig",
    mime: "text/x-twig"
  },
  {
    name: "VB.NET",
    mode: "vb",
    mime: "text/x-vb"
  },
  {
    name: "Verilog",
    mode: "verilog",
    mime: "text/x-verilog"
  },
  {
    name: "VHDL",
    mode: "vhdl",
    mime: "text/x-vhdl"
  },
  {
    name: "Vue",
    mode: "vue",
    mime: "text/x-vue"
  },
  {
    name: "XML",
    mode: "xml",
    mime: "application/xml"
  },
  {
    name: "YAML",
    mode: "yaml",
    mime: "text/x-yaml"
  }
];

export const LANGUAGES_FORMATTED = toHash(LANGUAGES, "mode");

export const THEMES = [
  {
    name: "3024-day",
    background: "#f7f7f7",
    color: "#3a3432"
  },
  {
    name: "3024-night",
    background: "#090300",
    color: "#d6d5d4"
  },
  {
    name: "abcdef",
    background: "#0f0f0f",
    color: "#defdef"
  },
  {
    name: "ambiance",
    background: "#202020",
    color: "#E6E1DC"
  },
  {
    name: "base16-dark",
    background: "#151515",
    color: "#e0e0e0"
  },
  {
    name: "base16-light",
    background: "#f5f5f5",
    color: "#202020"
  },
  {
    name: "bespin",
    background: "#28211c",
    color: "#9d9b97"
  },
  {
    name: "blackboard",
    background: "#0C1021",
    color: "#F8F8F8"
  },
  {
    name: "cobalt",
    background: "#002240",
    color: "#FFFFFF"
  },
  {
    name: "colorforth",
    background: "#000000",
    color: "#f8f8f8"
  },
  {
    name: "darcula",
    background: "#2B2B2B",
    color: "#A9B7C6"
  },
  {
    name: "dracula",
    background: "#282a36",
    color: "#f8f8f2"
  },
  {
    name: "duotone-dark",
    background: "#2a2734",
    color: "#6c6783"
  },
  {
    name: "duotone-light",
    background: "#faf8f5",
    color: "#b29762"
  },
  {
    name: "eclipse",
    background: "#FFFFFF",
    color: "#000000"
  },
  {
    name: "elegant",
    background: "#FFFFFF",
    color: "#000000"
  },
  {
    name: "erlang-dark",
    background: "#002240",
    color: "#FFFFFF"
  },
  {
    name: "gruvbox-dark",
    background: "#282828",
    color: "#bdae93"
  },
  {
    name: "hopscotch",
    background: "#322931",
    color: "#d5d3d5"
  },
  {
    name: "icecoder",
    background: "#666666",
    color: "#1d1d1b"
  },
  {
    name: "idea",
    background: "#FFFFFF",
    color: "#000000"
  },
  {
    name: "isotope",
    background: "#000000",
    color: "#e0e0e0"
  },
  {
    name: "lesser-dark",
    background: "#262626",
    color: "#EBEFE7"
  },
  {
    name: "liquibyte",
    background: "#000",
    color: "#fff"
  },
  {
    name: "lucario",
    background: "#2b3e50",
    color: "#f8f8f2"
  },
  {
    name: "material",
    background: "#263238",
    color: "#E9EDED"
  },
  {
    name: "mbo",
    background: "#2c2c2c",
    color: "#ffffec"
  },
  {
    name: "mdn-like",
    background: "#fff",
    color: "#999"
  },
  {
    name: "midnight",
    background: "#0F192A",
    color: "#D1EDFF"
  },
  {
    name: "monokai",
    background: "#272822",
    color: "#f8f8f2"
  },
  {
    name: "neat",
    background: "#FFFFFF",
    color: "#000000"
  },
  {
    name: "neo",
    background: "#ffffff",
    color: "#2e383c"
  },
  {
    name: "night",
    background: "#0a001f",
    color: "#f8f8f8"
  },
  {
    name: "nord",
    background: "#2e3440",
    color: "#d8dee9"
  },
  {
    name: "oceanic-next",
    background: "#304148",
    color: "#f8f8f2"
  },
  {
    name: "panda-syntax",
    background: "#292A2B",
    color: "#E6E6E6"
  },
  {
    name: "paraiso-dark",
    background: "#2f1e2e",
    color: "#b9b6b0"
  },
  {
    name: "paraiso-light",
    background: "#e7e9db",
    color: "#41323f"
  },
  {
    name: "pastel-on-dark",
    background: "#2c2827",
    color: "#8F938F"
  },
  {
    name: "railscasts",
    background: "#2b2b2b",
    color: "#f4f1ed"
  },
  {
    name: "rubyblue",
    background: "#112435",
    color: "#FFFFFF"
  },
  {
    name: "seti",
    background: "#151718",
    color: "#CFD2D1"
  },
  {
    name: "shadowfox",
    background: "#2a2a2e",
    color: "#b1b1b3"
  },
  {
    name: "solarized",
    background: "#FFFFFF",
    color: "#000000"
  },
  {
    name: "ssms",
    background: "#FFFFFF",
    color: "#000000"
  },
  {
    name: "the-matrix",
    background: "#000000",
    color: "#00FF00"
  },
  {
    name: "tnight-bright",
    background: "#000000",
    color: "#eaeaea"
  },
  {
    name: "tnight-eighties",
    background: "#000000",
    color: "#CCCCCC"
  },
  {
    name: "ttcn",
    background: "#FFFFFF",
    color: "#000000"
  },
  {
    name: "twilight",
    background: "#141414",
    color: "#f7f7f7"
  },
  {
    name: "vibrant-ink",
    background: "#000000",
    color: "#FFFFFF"
  },
  {
    name: "xq-dark",
    background: "#0a001f",
    color: "#f8f8f8"
  },
  {
    name: "xq-light",
    background: "#FFFFFF",
    color: "#000000"
  },
  {
    name: "yeti",
    background: "#ECEAE8",
    color: "#d1c9c0"
  },
  {
    name: "yonce",
    background: "#1C1C1C",
    color: "#d4d4d4"
  },
  {
    name: "zenburn",
    background: "#3f3f3f",
    color: "#dcdccc"
  }
];

export const THEMES_FORMATTED = toHash(THEMES, "name");

export const CANVAS_TEMPLATES = {
  "Mostly used": [
    {
      id: 15,
      name: "Facebook",
      width: "1200",
      height: "630",
      thumbnail: "facebook-shared-image.png",
      projectName: "codeimg-facebook-shared-image",
      details: ""
    },
    {
      id: 16,
      name: "Twitter",
      width: "506",
      height: "253",
      thumbnail: "twitter-instream-image.png",
      projectName: "codeimg-twitter-instream-image",
      details: ""
    },
    {
      id: 17,
      name: "Instagram",
      width: "1080",
      height: "1080",
      thumbnail: "instagram-photo-thumbnail.png",
      projectName: "codeimg-instagram-photo-thumbnail",
      details: ""
    }
  ],
  Facebook: [
    {
      id: 1,
      name: "Profile Photo",
      width: "180",
      height: "180",
      thumbnail: "facebook-profile.png",
      projectName: "codeimg-facebook-profile",
      details: ""
    },
    {
      id: 2,
      name: "Cover Photo",
      width: "820",
      height: "312",
      thumbnail: "facebook-cover-photo.png",
      projectName: "codeimg-facebook-cover-photo",
      details: ""
    },
    {
      id: 3,
      name: "Shared Image",
      width: "1200",
      height: "630",
      thumbnail: "facebook-shared-image.png",
      projectName: "codeimg-facebook-shared-image",
      details: ""
    },
    {
      id: 4,
      name: "Shared Link",
      width: "1200",
      height: "628",
      thumbnail: "facebook-shared-link.png",
      projectName: "codeimg-facebook-shared-link",
      details: ""
    },
    {
      id: 5,
      name: "Highlighted Image",
      width: "1200",
      height: "717",
      thumbnail: "facebook-highlighted-image.png",
      projectName: "codeimg-facebook-highlighted-image",
      details: ""
    },
    {
      id: 6,
      name: "Event Image",
      width: "1920",
      height: "1080",
      thumbnail: "facebook-event-image.png",
      projectName: "codeimg-facebook-event-image",
      details: ""
    }
  ],
  Twitter: [
    {
      id: 7,
      name: "Profile Photo",
      width: "400",
      height: "400",
      thumbnail: "twitter-profile-photo.png",
      projectName: "codeimg-twitter-profile-photo",
      details: ""
    },
    {
      id: 8,
      name: "Header Photo",
      width: "1500",
      height: "1500",
      thumbnail: "twitter-header-photo.png",
      projectName: "codeimg-twitter-header-photo",
      details: ""
    },
    {
      id: 9,
      name: "In-Stream Photo",
      width: "506",
      height: "253",
      thumbnail: "twitter-instream-image.png",
      projectName: "codeimg-twitter-instream-image",
      details: ""
    }
  ],
  Instagram: [
    {
      id: 10,
      name: "Profile Picture",
      width: "110",
      height: "110",
      thumbnail: "instagram-profile-photo.png",
      projectName: "codeimg-instagram-profile-photo",
      details: ""
    },
    {
      id: 11,
      name: "Photo Thumbnails",
      width: "161",
      height: "161",
      thumbnail: "instagram-photo.png",
      projectName: "codeimg-instagram-photo",
      details: ""
    },
    {
      id: 12,
      name: "Photo Size (Instagram App)",
      width: "1080",
      height: "1080",
      thumbnail: "instagram-photo-thumbnail.png",
      projectName: "codeimg-instagram-photo-thumbnail",
      details: "square"
    },
    {
      id: 13,
      name: "Photo Size (Instagram App)",
      width: "1080",
      height: "1350",
      thumbnail: "instagram-photo-thumbnail.png",
      projectName: "codeimg-instagram-photo-thumbnail",
      details: ""
    },
    {
      id: 14,
      name: "Instagram Stories",
      width: "1080",
      height: "1920",
      thumbnail: "instagram-stories-image.png",
      projectName: "codeimg-instagram-stories-image",
      details: ""
    }
  ]
};
